import { bind, Component, h, tag } from "omi";

import { AuthService } from "@/services/authService";
import { DropdownItem, NWDropdown, openModal } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { AuthEvents } from "./events";

export * from "./events";

type Props = {
  withUI?: boolean;
};

@tag("nw-authmanager")
export class NWAuthManager extends Component<Props> {
  static css = [tailwind];
  private authService: AuthService | undefined;

  async installed() {
    if (Store.features.hasFeature("projects.login")) {
      this.authService = new AuthService();
      await this.authService.getUser();
    }

    addEventListener(AuthEvents.LoginClicked, this.handleLogin);
  }

  @bind
  private handleLogout() {
    this.authService?.logout();
  }

  @bind
  private handleLogin() {
    if (Store.features.hasFeature("projects.custom_login")) {
      openModal("login", {});
    } else {
      const currentUrl = window.location.href;
      this.authService?.login(currentUrl);
    }
  }

  private createDropdownItems(): DropdownItem[] {
    const user = Store.user.info.value;

    const dropdownItems: DropdownItem[] = [
      {
        type: "link",
        icon: "message-smile-circle",
        text: "Visit community",
        href: "https://community.nextwork.org/",
      },
      { type: "divider" },
      {
        type: "link",
        icon: "file",
        text: "Terms & Conditions",
        href: "/terms",
      },
      {
        type: "link",
        icon: "key",
        text: "Privacy policy",
        href: "/privacy",
      },
    ];

    if (user == null) {
      dropdownItems.push(
        { type: "divider" },
        {
          type: "button",
          icon: "login",
          text: "Sign in",
          callback: this.handleLogin,
        },
      );
    } else {
      dropdownItems.push(
        { type: "divider" },
        {
          type: "button",
          icon: "logout",
          text: "Log out",
          callback: this.handleLogout,
        },
      );
    }

    return dropdownItems;
  }

  render({ withUI }: Props) {
    if (withUI) {
      // TODO remove this once we fully move away from the old sidebar
      const user = Store.user.info.value;
      const dropdownItems = this.createDropdownItems();

      return (
        <div class="flex space-x-3">
          <NWDropdown items={dropdownItems} withBorder={false}>
            <div class="flex space-x-3 items-center justify-center">
              <img src="/static/nextwork-icon-back.svg" alt="NextWork Icon" width={40} height={40} />
              {user && <span class="text-quaternary">Your NextWork</span>}
            </div>
          </NWDropdown>
        </div>
      );
    }

    return null;
  }
}
